"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
function BlogCardsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="rounded-xl overflow-hidden bg-muted/30 animate-pulse">
            <div className="aspect-[16/10] bg-muted/50" />
            <div className="p-6 space-y-4">
              <div className="h-6 bg-muted/50 rounded" />
              <div className="h-4 bg-muted/50 rounded w-3/4" />
              <div className="h-4 bg-muted/50 rounded w-1/2" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground text-sm">Failed to load blog posts.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground">No blog posts available at the moment.</p>
      </div>;
  }
  const displayPosts = posts.slice(0, 3);
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {displayPosts.map((post, i) => <Card key={post.id} data-index={i} className="group overflow-hidden shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1">
          {post.featuredImage && <div className="aspect-[16/10] overflow-hidden">
              <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-out-back)] group-hover:scale-105" />
            </div>}
          <CardHeader>
            <CardTitle className="text-xl font-display font-semibold text-foreground leading-tight line-clamp-2">
              {post.title}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {post.excerpt && <CardDescription className="text-muted-foreground line-clamp-3">
                <div dangerouslySetInnerHTML={{
            __html: post.excerpt
          }} />
              </CardDescription>}
            {post.link && <Link to={post.link} className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:text-primary-hover hover:underline transition-colors duration-[var(--duration-fast)]">
                Read More
                <ArrowRight className="size-4 transition-transform duration-[var(--duration-fast)] group-hover:translate-x-1" />
              </Link>}
          </CardContent>
        </Card>)}
    </div>;
}
export default function LatestInsights() {
  return <section className="py-16 px-6 md:py-24 bg-background">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
            Latest Insights
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Stay informed with expert perspectives on Nigerian real estate trends, investment strategies, and digital marketing excellence.
          </p>
        </div>

        <PostsProvider className="latest-insights-wrapper" wp_query={{
        per_page: 3,
        order: "desc",
        orderby: "date"
      }} embeds={["wp:featuredmedia"]} fields={["id", "title.rendered", "excerpt.rendered", "link", "date", "_embedded", "_links.wp:featuredmedia"]}>
          <BlogCardsConsumer />
        </PostsProvider>
      </div>
    </section>;
}